module.exports = __webpack_public_path__ + "static/1.2.B.6 CASA MERCEA - PLAN PARTER-518ab4818ee8982e3d3ab46757c573a6.jpg";